/*
 * DRV "Læs mere" på produktbeskrivelsen.
 * Robust: pakker beskrivelsens indhold i et nyt element (.drv-desc-inner), som
 * eksterne/blokerede CSS-regler på #product-description ikke rammer, og animerer
 * max-height på DET. Glat fold-ud + pil der vender, "Se mindre" folder sammen og
 * scroller tilbage til toppen. Skjuler knappen hvis teksten er kort.
 */
(function () {
  function init() {
    var desc = document.querySelector('.drv-desc #product-description') ||
               document.getElementById('product-description');
    var btn = document.querySelector('.drv-desc #read-more') ||
              document.getElementById('read-more');
    if (!desc || !btn || desc.dataset.drvReadmore) return;
    desc.dataset.drvReadmore = '1';

    // #product-description har en ekstern !important-højde vi ikke kan overstyre, og som
    // klipper alt indhold. Vi flytter derfor indholdet ud i et SØSKENDE-element (inde i
    // vores egen .drv-desc) og skjuler den oprindelige beholder.
    var inner = document.createElement('div');
    inner.className = 'drv-desc-inner is-collapsed';
    inner.id = 'drv-product-description';
    while (desc.firstChild) { inner.appendChild(desc.firstChild); }
    desc.parentNode.insertBefore(inner, desc.nextSibling);
    desc.style.display = 'none';

    function collapsedPx() {
      return parseFloat(getComputedStyle(inner).fontSize || '15') * 7.5;
    }

    inner.style.maxHeight = collapsedPx() + 'px';

    // Kort tekst: vis alt, skjul knap
    if (inner.scrollHeight <= collapsedPx() + 12) {
      inner.classList.remove('is-collapsed');
      inner.style.maxHeight = 'none';
      btn.style.display = 'none';
      return;
    }

    // Tekst-wrapper på knappen (så ::after-ikonet bevares når teksten skiftes)
    if (!btn.querySelector('.drv-rm-text')) {
      var label = (btn.textContent || 'Læs mere').trim() || 'Læs mere';
      btn.textContent = '';
      var span = document.createElement('span');
      span.className = 'drv-rm-text';
      span.textContent = label;
      btn.appendChild(span);
    }
    function setLabel(t) { btn.querySelector('.drv-rm-text').textContent = t; }

    function expand() {
      inner.style.maxHeight = inner.scrollHeight + 'px';
      inner.classList.remove('is-collapsed');
      setLabel('Se mindre');
      btn.classList.add('is-open');
      var onEnd = function (e) {
        if (e.propertyName !== 'max-height') return;
        if (!inner.classList.contains('is-collapsed')) inner.style.maxHeight = 'none';
        inner.removeEventListener('transitionend', onEnd);
      };
      inner.addEventListener('transitionend', onEnd);
    }

    function collapse() {
      inner.style.maxHeight = inner.scrollHeight + 'px';
      inner.getBoundingClientRect(); // reflow
      requestAnimationFrame(function () {
        inner.classList.add('is-collapsed');
        inner.style.maxHeight = collapsedPx() + 'px';
      });
      setLabel('Læs mere');
      btn.classList.remove('is-open');
      var box = desc.closest('.drv-desc') || desc;
      var y = window.pageYOffset + box.getBoundingClientRect().top - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (inner.classList.contains('is-collapsed')) { expand(); }
      else { collapse(); }
    });
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
